import { render } from "./AppKryesia.vue?vue&type=template&id=1aa767e9&scoped=true"
const script = {}

import "./AppKryesia.vue?vue&type=style&index=0&id=1aa767e9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aa767e9"]])

export default __exports__